import React from 'react';
import './../styles/profesional.css';
import { Outlet } from 'react-router-dom';
import NavbarTop from './profesional/Navbartop';

const Profesional = () => {
    return (
        <div className="app-profesional app-container">
            <NavbarTop />
            <div className="main-content">
                <div className="page-container">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default Profesional;